<script>
import httpService from "@/core/api/request";
export default {
  data: function() {
    return {
      parents: null
    };
  },
  methods: {
    getParentCategories: function() {
      let httpRequest = {
        params: "?parent_id=isn:null",
        module: "product_categories"
      };
      this.get(httpRequest)
        .then(parents => {
          this.parents = parents.data;
        })
        .catch(() => {
          this.parents = null;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product_categories/mixins.vue